export const FILTER_CACHE_PREFIX = 'filterCache:';
export const FILTER_CACHE_OWNER_KEY = `${FILTER_CACHE_PREFIX}__owner`;

export function clearAllFilterCaches(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(FILTER_CACHE_PREFIX)) keys.push(key);
    }
    keys.forEach(k => localStorage.removeItem(k));
  } catch {
    // ignore storage errors
  }
}

/**
 * Called after each sign-in. The app signs in every time a Teams tab opens, so wiping the filters here made them reset
 * whenever the user came back to the tab. They are kept for the user who saved them and cleared when another user signs
 * in (or when the owner is unknown), so nobody sees the previous user's selection on a shared machine.
 */
export function keepFilterCachesForUser(username?: string | null): void {
  const user = username?.trim().toLowerCase() ?? '';
  try {
    if (user && localStorage.getItem(FILTER_CACHE_OWNER_KEY) === user) return;
    clearAllFilterCaches();
    if (user) localStorage.setItem(FILTER_CACHE_OWNER_KEY, user);
  } catch {
    // ignore storage errors
  }
}
